import { render, staticRenderFns } from "./program-pasport.vue?vue&type=template&id=486248d7&scoped=true&"
import script from "./program-pasport.vue?vue&type=script&lang=ts&"
export * from "./program-pasport.vue?vue&type=script&lang=ts&"
import style0 from "./program-pasport.vue?vue&type=style&index=0&id=486248d7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486248d7",
  null
  
)

export default component.exports